import { render, staticRenderFns } from "./NormalSearchNav470.vue?vue&type=template&id=61887c74&scoped=true"
import script from "./NormalSearchNav470.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav470.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61887c74",
  null
  
)

export default component.exports